<template>
    <el-tree
        ref="tree"
        :data="options"
        show-checkbox
        node-key="id"
        :props="defaultProps"
        :default-expanded-keys="['Trial']"
    />
</template>

<script>
export default {
    props: {
        options: Array,
        selectedKeys: Array,
        allChildNodes: Array
    },
    data() {
        return {
            defaultProps: {
                children: "children",
                label: "label"
            },
        };
    },
    watch: {
        selectedKeys() {
            var selectedChild = [];
            this.allChildNodes.forEach(child => {
                this.selectedKeys.forEach(key => {
                    if (child == key) {
                        selectedChild.push(key);
                    }
                });
            });

            this.$refs.tree.setCheckedKeys(selectedChild);
        }
    },
    methods: {
        getCheckedKeys() {
            var checkedKey = this.$refs.tree.getCheckedKeys();
            var halfCheckedKey = this.$refs.tree.getHalfCheckedKeys();
            return checkedKey.concat(halfCheckedKey);
        },
        clearNodes() {
            this.$refs.tree.setCheckedKeys([]);
        }
    }
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/UMS/TrialManagement/RoleTreeNode.vue